const pushStatusObj = (filteredList, element, competitionIds, filteredEventList) => {

  const obj = Object.assign({}, element);
  obj.events = filteredList;
  if (filteredList.length > 0 && (competitionIds.includes(element?.id) || competitionIds?.length < 1)) {
    return filteredEventList.push(obj);
  }
};

const includesIgnoreCase = (value, search) => (value || '').toLowerCase().includes(search);

const eventMatchesSearch = (event, searchText, normalizedSearch) => (
  includesIgnoreCase(event.homeTeam, normalizedSearch)
  || includesIgnoreCase(event.awayTeam, normalizedSearch)
  || (event.sbsEventId != null && String(event.sbsEventId).includes(searchText))
);

export const shouldShowLiveScoresSearchEmptyState = (searchText, filteredData) => (
  searchText !== '' && Array.isArray(filteredData) && filteredData.length <= 0
);

export const filterLiveScoresBySearchText = (competitions, searchText) => {
  if (!competitions || !searchText) {
    return competitions;
  }

  const normalizedSearch = searchText.toLowerCase();

  return competitions.reduce((result, competition) => {
    if (includesIgnoreCase(competition.title, normalizedSearch)) {
      result.push(competition);
      return result;
    }

    const events = (competition.events || []).filter(event =>
      eventMatchesSearch(event, searchText, normalizedSearch)
    );

    if (events.length) {
      result.push({ title: competition.title, events });
    }

    return result;
  }, []);
};

export const applyLiveScoresHeaderFilter = (competitions, filter) => {
  let filteredEventList = [];
  /*
    onlyLive = Devam Eden Filtresi, 'PLAYING'
    streamOnBilyoner = Bilyoner Yayınları Filtresi, "NONE", -- canlı yayın filtresi için, 'BILYONER_TV'
  */

  
  competitions.forEach(element => {
    if (filter.onlyLive && !filter.streamOnBilyoner && !filter.liveCanBet ) {
        
      const eventList = [...element.events];
      const filteredList = eventList.filter(e => {
        if (e.matchStatus.type === 'PLAYING') {
          return e;
        }
      });
      pushStatusObj(filteredList, element, filter.competitionIds, filteredEventList);
    }
    if (filter.onlyLive && !filter.streamOnBilyoner && filter.liveCanBet) {
        
      const eventList = [...element.events];
      const filteredList = eventList.filter(e => {
        if (e.matchStatus.type === 'PLAYING' && e.isLive === 1) {
          return e;
        }
      });
      pushStatusObj(filteredList, element, filter.competitionIds, filteredEventList);
    }

    if (filter.streamOnBilyoner && !filter.onlyLive && !filter.liveCanBet  ) {
      const eventList = [...element.events];
      const filteredList = eventList.filter(e => {
        //Bilyoner Yayınları kontrolünü "NONE Değilse" şeklinde yapıyoruz.
        if (e.streamType !== 'NONE' ) {
          return e;
        }
      });
      pushStatusObj(filteredList, element, filter.competitionIds, filteredEventList);
    }
    if (filter.streamOnBilyoner && !filter.onlyLive && filter.liveCanBet) {
      const eventList = [...element.events];
      const filteredList = eventList.filter(e => {
        //Bilyoner Yayınları kontrolünü "NONE Değilse" şeklinde yapıyoruz.
        if (e.streamType !== 'NONE' && e.isLive === 1) {
          return e;
        }
      });
      pushStatusObj(filteredList, element, filter.competitionIds, filteredEventList);
    }
    if (filter.streamOnBilyoner && filter.onlyLive && !filter.liveCanBet  ) {

      const eventList = [...element.events];
      const filteredList = eventList.filter(e => {
        if (e.streamType !== 'NONE' && e.matchStatus.type === 'PLAYING') {
          return e;
        }
      });
      pushStatusObj(filteredList, element, filter.competitionIds, filteredEventList);

    }
    if (filter.streamOnBilyoner && filter.onlyLive && filter.liveCanBet  ) {

      const eventList = [...element.events];
      const filteredList = eventList.filter(e => {
        if (e.streamType !== 'NONE' && e.matchStatus.type === 'PLAYING' && e.isLive === 1)  {
          return e;
        }
      });
      pushStatusObj(filteredList, element, filter.competitionIds, filteredEventList);

    }
    if (!filter.onlyLive && !filter.streamOnBilyoner && filter.liveCanBet ) {
      const eventList = [...element.events];
      const filteredList = eventList.filter(e => {
        if (e.isLive === 1)  {
          return e;
        }
      });
      pushStatusObj(filteredList, element, filter.competitionIds, filteredEventList);
    }
    if (!filter.onlyLive && !filter.streamOnBilyoner && !filter.liveCanBet ) {
      pushStatusObj(element.events, element, filter.competitionIds, filteredEventList);
    }
  });
  return filteredEventList;
};
